import gql from 'graphql-tag';

export const BANKING_ACCOUNT_STATEMENT_DOCUMENT = gql`
  subscription bankingAccountStatementSubscribtion($accountId: String!) {
    bankingAccountStatementDocumentReady(accountId: $accountId) {
      accountId
      pdfFileId
      xlsxFileId
    }
  }
`;

export const DOWNLOAD_FILE = gql`
  subscription downloadFileSubscription($userId: String!) {
    fileDownloadReady(userId: $userId) {
      userId
      fileId
    }
  }
`;
